import { TableColumnsType } from 'antd';
import dayjs from '/react4xp/mixins/dayjsConfig';
import { localize } from '/react4xp/mixins/helpers';

export const columns = (translations: Record<string, string>, language: string): TableColumnsType => [
    {
        title: localize('iin-bin', translations),
        dataIndex: 'iinBin',
        key: 'iinBin',
    },
    {
        title: localize('np-name', translations),
        dataIndex: 'npName',
        key: 'npName',
    },
    {
        title: localize('type-regime', translations),
        dataIndex: `typeName`,
        key: 'name',
    },
    {
        title: localize('start-date', translations),
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (a) => (a ? dayjs(a).format('DD.MM.YYYY') : ''),
    },
    {
        title: localize('end-date', translations),
        dataIndex: 'endDate',
        key: 'endDate',
        render: (a) => (a && dayjs(a).isValid() ? dayjs(a).format('DD.MM.YYYY') : '-'),
    },
];
